import * as Integrations from '@sentry/integrations'
import * as Sentry from '@sentry/react'
import { isProductionBuild } from '../../build/utils/environment'
import { getRelease } from '../../build/utils/sentry'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const SERIALIZE_DEPTH = 10

const release = getRelease()

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

// eslint-disable-next-line import/prefer-default-export
export const initialiseSentry = ({ isEnabled = true }) => {
  Sentry.init({
    // Unique identifier
    dsn: process.env.SENTRY_DSN,
    // Environment in which the app is running
    environment: process.env.ACTIVE_ENV,
    // Add additional data about the error to the report
    integrations: [
      new Integrations.ExtraErrorData({ depth: SERIALIZE_DEPTH }),
      new Integrations.CaptureConsole({ levels: [`error`] }),
      new Sentry.BrowserTracing(),
    ],
    // Filter out exceptions that originate in code that is loaded from a URL
    // that doesn't match this Regex
    allowUrls: [
      // Match local development URL, local build URL, staging servers and production
      /^https:\/\/([a-z]+\.sleepstation.test:8091|client\.[a-z]+\.sleepstation\.test|client(-(alpha\d+|staging))?\.sleepstation\.org\.uk)/,
    ],
    // Set the current release
    release,
    enabled: isEnabled,
    // Sample 100% of errors
    sampleRate: 1,
    // Performance sampling:
    tracesSampleRate: isProductionBuild() ? 0.2 : 1.0,
    tracePropagationTargets: [
      /^https:\/\/.*\.sleepstation.org\.uk/,
      /^https:\/\/pedr\.sleepstation\.test/,
    ],

    // Fix bug with serialisation of extra data
    // See: https://github.com/getsentry/sentry-javascript/issues/1964
    normalizeDepth: SERIALIZE_DEPTH + 1,
    //  Uncomment to enable debugging to the console
    // debug: true
  })
}
